import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Shipping module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * No "coming soon" note. The route is gated by dept.shipping in allRoutes.js.
 */
const MODULES = ["epo", "display", "app-visitors", "tasks", "kpi"];

const Shipping = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-truck-line"
                        eyebrow="Logistics"
                        title="Shipping"
                        subtitle="Outbound shipments, packing, and carrier tracking"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shipping" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="shipping" title="Shipping modules" icon="ri-truck-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shipping;
